<template>
    <div class="page">
        <div class="page-header">
            江北心e站&nbsp;&nbsp;家校直通车
        </div>
        <div class="page-main" :style="{height: `${containerHeight}px`}">
            <el-form :model="queryForm" :rules="formRule" ref="form" label-width="100px" class="form">
                <el-form-item label="姓名" prop="createUserName">
                    <el-input v-model.trim="queryForm.createUserName" :maxlength="10"></el-input>
                </el-form-item>
                <el-form-item label="联系方式" prop="mobile">
                    <el-input v-model.trim="queryForm.mobile" :maxlength="20"></el-input>
                </el-form-item>
                <el-form-item label="类型" prop="id">
                    <el-select v-model="queryForm.id">
                        <el-option :label="moduleItem.name" :value="moduleItem.id"
                                   v-for="moduleItem in moduleList"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="留言内容" prop="content">
                    <el-input type="textarea" :maxlength="500" :rows="5" v-model.trim="queryForm.content"></el-input>
                </el-form-item>
                <el-form-item label="视频">
                    <uploader :extList="['mp4', 'flv']" showMode="button" @delete="deleteVideoHandler"
                              @input="uploadVideoHandler"></uploader>
                </el-form-item>
                <el-form-item label="图片">
                    <div class="pic-item" :style="{backgroundImage: `url(${picItem})`}"
                         v-for="(picItem, picIndex) in queryForm.photoJson">
                        <span class="delete-icon" @click="deletePic(picIndex)"></span>
                    </div>
                    <web-uploader
                        prefixPath="heartsOfRiver"
                        v-model="files"
                        :multiple="false"
                        :extList="['jpeg', 'jpg', 'bmp', 'gif', 'png']"
                        showMode="image"
                        showResult="image"
                    >
                    </web-uploader>
                </el-form-item>
            </el-form>
            <div class="btn-container">
                <el-button @click="submit" type="primary" size="medium">保存</el-button>
            </div>
        </div>

    </div>
</template>

<script>
    import baseMixin from '@/mixins/baseMixin';
    import {
        addTrainRecord,
        getTrainTypeListBySchoolId
    } from '@/api/outer/outer';
    import WebUploader from '@/components/Uploader/WebUploader';

    import Uploader from '@/components/Uploader/VideoUploader';

    export default {
        name: "messageAdd",
        data: function () {
            return {
                schoolId: this.$route.query.schoolId,
                queryForm: {
                    id: '',
                    content: '',
                    photoJson: [],
                    mobile: '',
                    createUserName: '',
                    dictionaryCode: ''
                },
                videoUrl: '',
                videoId: '',
                files: [],
                formRule: {
                    content: [{
                        required: true,
                        message: '请填写留言内容',
                        trigger: 'blur'
                    }],
                    createUserName: [{
                        required: true,
                        message: '请填写姓名',
                        trigger: 'blur'
                    }],
                    mobile: [{
                        required: true,
                        message: '请填写联系方式',
                        trigger: 'blur'
                    }],
                    id: [{
                        required: true,
                        message: '请选择类型',
                        trigger: 'blur'
                    }],
                },
                moduleList: [],

                containerHeight: 0
            }
        },
        components: {
            Uploader,
            WebUploader
        },
        mixins: [baseMixin],
        created() {
            getTrainTypeListBySchoolId({
                schoolId: this.schoolId
            })
                .then(res => res.data)
                .then(data => {
                    this.moduleList = data.data.filter(({state}) => state === 1);
                    if (this.moduleList.length !== 0) {
                        this.queryForm.id = this.moduleList[0].id;
                    }
                })
        },
        mounted() {
            this.containerHeight = window.innerHeight - 300;
        },
        methods: {
            uploadVideoHandler(data) {
                this.videoUrl = data[0].url;
                this.videoId = data[0].serverFileId;
                this.$refs.form.validateField('videoUrl');
            },
            deleteVideoHandler() {
                this.videoUrl = '';
                this.videoId = '';
            },
            submit() {
                this.queryForm.photoJson = this.files;
                this.$refs.form.validate((isValid) => {
                    if (isValid) {
                        const currentModuleItem = this.moduleList.find(({id}) => id === this.queryForm.id);
                        const args = {
                            videoJson: {
                                videoId: this.videoId,
                                videoUrl: this.videoUrl
                            },
                            photoJson: this.queryForm.photoJson,
                            schoolId: this.schoolId,
                            typeId: this.queryForm.id,
                            dictionaryCode: currentModuleItem.dictionaryCode,
                            dictionaryName: currentModuleItem.dictionaryName,
                            typeName: currentModuleItem.name,
                            mobile: this.queryForm.mobile,
                            createUserName: this.queryForm.createUserName,
                            content: this.queryForm.content
                        };
                        addTrainRecord(args)
                            .then(res => res.data)
                            .then(data => {
                                if (data.result) {
                                    this.$message({
                                        type: 'success',
                                        message: '您的建议已提交成功，请等待学校处理'
                                    });
                                    setTimeout(() => {
                                        window.location.reload()
                                    }, 1000);
                                }
                            })
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/mixin";

    .page {
        padding: 20px;
        width: 40%;
        margin: 20px auto 20px auto;
        height: 100%;
        background-color: #fff;
    }

    .page-main {
        padding: 20px 0 0 0;
        overflow-y: auto;
    }

    .page-header {
        font-size: 30px;
        text-align: center;
        margin-top: 20px;
    }

    .btn-container {
        margin-top: 20px;
        text-align: right;
    }

    .pic-item {
        @include cover-bg;
        @include wh(148px, 148px);
        box-sizing: border-box;
        border: 1px solid #ccc;
        float: left;
        margin: 0 10px 10px 0;
        position: relative;

        .delete-icon {
            cursor: pointer;
            background-image: url(../../assets/images/wxcep_phone_close.png);
            z-index: 1000;
            position: absolute;
            right: 0;
            top: 0;
            @include wh(30px, 30px);
            background-size: cover;
        }
    }

    .upload-hint {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 148px;
        height: 148px;
        line-height: 146px;
        float: left;

        &:hover, &:focus {
            border-color: #409EFF;
            color: #409EFF;
        }

        font-size: 28px;
        color: #8c939d;
    }
</style>



// WEBPACK FOOTER //
// src/views/outer/messageAdd.vue